import { render } from "./AdDocViewInvitationsRemoveButton.vue?vue&type=template&id=71557e52&ts=true"
import script from "./AdDocViewInvitationsRemoveButton.vue?vue&type=script&lang=ts"
export * from "./AdDocViewInvitationsRemoveButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__